// Stimulus controller manifest (manually maintained).
import { application } from "./application"

import NavController from "./nav_controller"
application.register("nav", NavController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)
